import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registerdoc-form',
  templateUrl: './registerdoc-form.component.html',
  styleUrls: ['./registerdoc-form.component.css']
})
export class RegisterdocFormComponent implements OnInit {

  title="Add Registered Document";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/registereddoc/registerdoc-form/registerdoc-form.component.ts